// menuData.js
import alasql from 'alasql';
import { iconsNew } from './icons'; // Ensure this path is correct

export const MenuData = () => {
    const role = localStorage.getItem('role');

    // Fetch tabs
    let tabs = alasql(
        `SELECT DISTINCT menu_section AS tab FROM resource_permistions WHERE ${role}_list=true`
    ).map(({ tab }) => tab);

    // Fetch resources for each tab
    let resourcesMenus = tabs.map((tab) =>
        alasql(
            `SELECT 
                CASE WHEN resource_name='dashboard' THEN '/' ELSE '/' + resource_name END AS url, 
                resource_name AS title 
             FROM resource_permistions 
             WHERE menu_section="${tab}" AND ${role}_list=true`
        )
    );

    // Construct menu data
    return tabs.map((t, index) => ({
        name: 'section' + index,
        title: t,
        icon: iconsNew[t],
        links: resourcesMenus[index],
    }));
};

export { iconsNew };
